import { asyncModule } from '../../utils/async-module';
import * as JSModules from '../../components/modules';

export const asyncAdvTopBottom = () => {
  const $advTopDataNodes = document.querySelectorAll('.js-adv-container-top[data-state="to-insert"]');
  const $advBottomDataNodes = document.querySelectorAll('.js-adv-container-bottom[data-state="to-insert"]');
  if ($advTopDataNodes.length || $advBottomDataNodes.length) {
    const { start, getInit, error } = asyncModule(JSModules.advTopBottomModule);
    start();
    import('../../components/adv/adv-top-bottom').then(getInit({ $advTopDataNodes, $advBottomDataNodes })).catch(error);
  }
};

export const asyncAdvArticle = () => {
  const $advTopDataNode = document.querySelector('#dataAdvTop');
  const $advInReadVideoDataNode = document.querySelector('#dataAdvVideoInRead');
  const $advInArticleDataNode = document.querySelector('#dataAdvInArticle');
  const { shouldInit, start, getInit, error } = asyncModule(JSModules.advArticleModule);
  if (shouldInit({ $advTopDataNode, $advInReadVideoDataNode, $advInArticleDataNode })) {
    start();
    import('../../components/adv/adv-article')
      .then(getInit({ $advTopDataNode, $advInReadVideoDataNode, $advInArticleDataNode }))
      .catch(error);
  }
};

export const asyncAdvSkin = () => {
  const $advSkinDataNode = document.querySelector('#advContainer_skin');
  const { shouldInit, start, getInit, error } = asyncModule(JSModules.advSkinModule);
  if ($advSkinDataNode && shouldInit()) {
    start();
    import('../../components/adv/adv-skin').then(getInit($advSkinDataNode)).catch(error);
  }
};

export const asyncAdvIntro = () => {
  const $advIntroDataNode = document.querySelector('#dataAdvIntro');
  const { shouldInit, start, getInit, error } = asyncModule(JSModules.advIntroModule);
  if ($advIntroDataNode && shouldInit()) {
    start();
    import('../../components/adv/adv-intro').then(getInit($advIntroDataNode)).catch(error);
  }
};
